import React from "react";
import { Bar } from "react-chartjs-2";

const ChartBart = (props) => {
  const { title, color, dataChart = [] } = props;

  const months = [];
  const values = [];

  dataChart.map((data) => months.push(data.month));
  dataChart.map((data) => values.push(data.value));

  const data = {
    labels: months,
    datasets: [
      {
        label: title,
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
        hoverBackgroundColor: color,
        hoverBorderColor: color,
        data: values,
      },
    ],
  };

 // const max_of_array = Math.max.apply(Math, values);

  return (
    <div>
      <Bar
        data={data}
        width={400}
        height={400}
        options={{
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default ChartBart;
